// If the process object doesn't exist, we're likely using webpack dev server which does not inject configs in the HTML.
// In that case, initialize the process object with values provided by webpack at build time.

// In production we expect the server to initialize the process object before loading any scripts, see scripts/server.mjs for more info.
if (!window.process) {
    window.process = {
        env: {
            NODE_ENV: bundled.env.NODE_ENV,
            NODE_VERSION: bundled.env.NODE_VERSION,
            VERSION: bundled.env.VERSION,
            PUBLIC_URL: bundled.env.PUBLIC_URL,
            LOGGER_WSS_ENDPOINT: bundled.env.LOGGER_WSS_ENDPOINT,
            REMOVE_NOTIFICATIONS_DELAY: bundled.env.REMOVE_NOTIFICATIONS_DELAY,
            IMAGE_URL_PREFIX: bundled.env.IMAGE_URL_PREFIX,
            ASSET_STORAGE_URL: bundled.env.ASSET_STORAGE_URL,
            PUBLISHING_SERVICE_URL: bundled.env.PUBLISHING_SERVICE_URL,
            TOKENLESS_REDIRECT_URL: bundled.env.TOKENLESS_REDIRECT_URL,
            PACKAGES_SFDC_ORG_OAUTH_URL: bundled.env.PACKAGES_SFDC_ORG_OAUTH_URL,
            LOGOUT_REDIRECT_URL: bundled.env.LOGOUT_REDIRECT_URL,
            SUPPORT_URL: bundled.env.SUPPORT_URL,
            PARTNER_COMMUNITY_URL: bundled.env.PARTNER_COMMUNITY_URL,
            COMMERCE_AUTH_URL: bundled.env.COMMERCE_AUTH_URL,
            STRIPE_CONNECT_URL: bundled.env.STRIPE_CONNECT_URL,
            STRIPE_CLIENT_ID: bundled.env.STRIPE_CLIENT_ID,
            FEATURE_FLAG_PROXY_URL: bundled.env.FEATURE_FLAG_PROXY_URL,
            FEATURE_FLAG_CLIENT_KEY: bundled.env.FEATURE_FLAG_CLIENT_KEY,
            FEATURE_FLAG_APP_NAME: bundled.env.FEATURE_FLAG_APP_NAME,
            FEATURE_FLAG_REFRESH_INTERVAL: bundled.env.FEATURE_FLAG_REFRESH_INTERVAL,
            PREVIEW_LISTING_URL: bundled.env.PREVIEW_LISTING_URL,
            SHOW_ANNOUNCEMENT_BANNER: bundled.env.SHOW_ANNOUNCEMENT_BANNER,
            SHOW_MAINTENANCE_BANNER: bundled.env.SHOW_MAINTENANCE_BANNER,
            MAINTENANCE_BANNER_STARTDATE: bundled.env.MAINTENANCE_BANNER_STARTDATE,
            MAINTENANCE_BANNER_ENDDATE: bundled.env.MAINTENANCE_BANNER_ENDDATE,
            IN_MAINTENANCE: bundled.env.IN_MAINTENANCE
        }
    };
}

// Use dynamic import here because regular imports are resolved before any code is executed.
// We need to setup the environment variables before importing and evaluating any modules.
import('./main');
